import Vue from 'vue';

export async function linkInterview() {
  let socketUrl = Vue.prototype.$isOnline ?
    'wss://wss.jiemo.net/9507' :
    'wss://wss.dev.jiemo.net/9507';
  let ws = new WebSocket(socketUrl);
  return new Promise((resolve) => {
    ws.addEventListener('open', () => {
      return resolve(ws);
    });
  });
}

export function sendLoginInfo(ws, userInfo) {
  function getExplorerInfo() {
    let explorer = navigator.userAgent.toLowerCase();
    if (explorer.indexOf('msie') >= 0) {
      let ver = explorer.match(/msie ([\d.]+)/)[1];
      return { type: 'IE', version: ver };
    } else if (explorer.indexOf('firefox') >= 0) {
      let ver = explorer.match(/firefox\/([\d.]+)/)[1];
      return { type: 'Firefox', version: ver };
    } else if (explorer.indexOf('chrome') >= 0) {
      let ver = explorer.match(/chrome\/([\d.]+)/)[1];
      return { type: 'Chrome', version: ver };
    } else if (explorer.indexOf('opera') >= 0) {
      let ver = explorer.match(/opera.([\d.]+)/)[1];
      return { type: 'Opera', version: ver };
    } else if (explorer.indexOf('Safari') >= 0) {
      let ver = explorer.match(/version\/([\d.]+)/)[1];
      return { type: 'Safari', version: ver };
    }
  }
  let newdata = {
    userId: userInfo.userid,
    crm_id: '',
    platform: 5,
    body: {
      msgCode: 999,
      txt: 'login'
    },
    ext: {
      device: `${getExplorerInfo().type},${getExplorerInfo().version}`,
    }
  };
  let senddata = JSON.stringify(newdata);
  ws.send(senddata);
  // 获取浏览器信息
}
